import http from "./http";

export const getSettings = async () => {
  const response = await http.get("/settings");
  return response.data;
};

export const updateSettings = async (settings) => {
  const response = await http.put("/settings", settings);
  return response.data;
};